import { useEffect, useState } from "react";

const ScamNotification = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("scamNotificationDismissed");
    if (dismissed !== "true") {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem("scamNotificationDismissed", "true");
  };

  if (!isVisible) return null;

  return (
    <div id="scamNotification" className="notification">
       <strong className="scam-content-black">Government official impersonation scam alert</strong><br></br>
      <span className="scam-content-black">Government officials will NEVER ask you to transfer money or disclose bank log-in details over a phone call. Call the 24/7 <a href="http://www.scamshield.gov.sg" target="_blank"
                        rel="noreferrer" className="scam-content-blue">ScamShield</a> Helpline at 1799 if you are unsure if something is a scam.</span>
      <button className="btn-close" onClick={handleClose}>
        
      </button>
    </div>
  );
};

export default ScamNotification;
